document.querySelectorAll('[data-link]').forEach((link) => {
  let url = link.dataset.link;
  if(!url) return

  link.addEventListener('click', (e) => {
    location.href = url
  })
})